import { NgModule } from '@angular/core';
import { ZoomPageTemplateComponent } from './zoom-page-template.component';
import { ZoomFooterComponent } from './zoom-footer/zoom-footer.component';
import { ZoomHeaderComponent } from './zoom-header/zoom-header.component';
import { ZoomFooterRaetComponent } from './zoom-footer-raet/zoom-footer-raet.component';
import { ZoomWhiteLabelingModule } from 'zoom-white-labeling';

@NgModule({
  imports: [
    ZoomWhiteLabelingModule
  ],
  declarations: [ZoomPageTemplateComponent, ZoomFooterComponent, ZoomHeaderComponent, ZoomFooterRaetComponent],
  exports: [ZoomPageTemplateComponent, ZoomFooterComponent, ZoomHeaderComponent, ZoomFooterRaetComponent]
})
export class ZoomPageTemplateModule { }
